import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import moment from 'moment';
import UsergroupItem from '../components/Usergroup/UsergroupItem';

const trackSelector = (state, props) =>
  state.map.selectedDay.tracks[props.user.id];

const nodataSelector = createSelector(
  trackSelector,
  track => (track ? undefined : 'Нет данных'),
);

const statsSelector = createSelector(
  trackSelector,
  track => track && track.stats,
);

const reportSelector = createSelector(
  trackSelector,
  track => {
    if (track && track.reports && track.reports.length > 0) {
      return track.reports.map(r => `${r.count}${r.type ? r.type : ''}`).join('/');
    }
    return undefined;
  },
);

const statsActivitySelector = createSelector(
  statsSelector,
  stats => stats && stats.lastActivity,
);

const formatTime = time => (time
  ? moment(time).format('HH:mm')
  : ''
);

const activitySelector = createSelector(
  statsActivitySelector,
  time => formatTime(time),
);

const statsStartVideoSelector = createSelector(
  statsSelector,
  stats => stats && stats.startVideoTime,
);

const startVideoSelector = createSelector(
  statsStartVideoSelector,
  time => formatTime(time),
);

const statsEndVideoSelector = createSelector(
  statsSelector,
  stats => stats && stats.endVideoTime,
);

const endVideoSelector = createSelector(
  statsEndVideoSelector,
  time => formatTime(time),
);

const statsVideoLengthSelector = createSelector(
  statsSelector,
  stats => stats && stats.videoLength,
);

const videoCountSelector = createSelector(
  trackSelector,
  track => track && track.medias.length,
);

const getMetrics = (videoLength, videoCount) => {
  const th = Math.floor(videoLength / 1000 / 60 / 60);
  const tm = Math.floor(videoLength / 1000 / 60) - (th * 60);
  let metrics = '';
  if (th !== 0 || tm !== 0) {
    metrics = videoCount ? ` ${videoCount}/` : '';
    if (th !== 0) {
      metrics += `${th}ч.`;
    }
    if (tm !== 0) {
      metrics += `${tm}${th ? 'м.' : 'мин.'}`;
    }
  }
  return metrics;
};

const metricsSelector = createSelector(
  statsVideoLengthSelector,
  videoCountSelector,
  (videoLength, videoCount) => (videoLength && videoCount
    ? getMetrics(videoLength, videoCount)
    : ''
  ),
);

/*
const statsDistanceSelector = createSelector(
  statsSelector,
  stats => stats && stats.distance,
);

const statsMemorySelector = createSelector(
  statsSelector,
  stats => stats && stats.memory,
); */

const statsBatteySelector = createSelector(
  statsSelector,
  stats => stats && stats.battery,
);

const batteySelector = createSelector(
  statsBatteySelector,
  battery => battery && `${parseInt(battery, 10)}%`,
);

const mapStateToProps = (state, props) => ({
  nodata: nodataSelector(state, props),
  activity: activitySelector(state, props),
  startVideo: startVideoSelector(state, props),
  endVideo: endVideoSelector(state, props),
  metrics: metricsSelector(state, props),
  // memory: statsMemorySelector(state, props),
  battery: batteySelector(state, props),
  report: reportSelector(state, props),
});

export default connect(mapStateToProps)(UsergroupItem);



// WEBPACK FOOTER //
// ./src/containers/UsergroupItem.js